var qvQtyInput = null;

function qvDecreaseQuantity() {
  if (qvQtyInput.value > 1) {
    qvQtyInput.value--;
  }
}

function qvIncreaseQuantity() {
  if (qvQtyInput.value < 100) {
    qvQtyInput.value++;
  }
}

function qvUpdateATCbtn(){
  let totalItems = parseInt((pdpQtyInput.value || 1));
  const checkedBoxes = document.querySelectorAll('.addon-card__checkbox:checked');
  checkedBoxes.forEach((el) => {
    const card = el.closest('.addon-card');
    const itemQty = parseInt(card.dataset.qty);
    totalItems += itemQty;
  });
  if(totalItems > 1){
    pdpAddBtns.forEach((btn) => btn.textContent = `Add ${totalItems} items to cart`);
  } else {
    pdpAddBtns.forEach((btn) => btn.textContent = 'Add to cart');
  }
}

window.addEventListener('DOMContentLoaded',() => {
  const addOnSwiperEl = document.getElementById('add-ons-swiper');
  if(addOnSwiperEl){
    const addOnSwiper = new Swiper(addOnSwiperEl,{
      slidesPerView: 2.5,
      breakpoints:{
        500:{slidesPerView: 3.5},
        768:{slidesPerView: 2.5},
        900:{slidesPerView: 3},
        1024:{slidesPerView: 2},
        1200:{slidesPerView: 3}
      },
      spaceBetween: 18,
      simulateTouch: false,
      watchSlidesProgress: true,
      navigation:{nextEl: '#add-ons-next',prevEl: '#add-ons-prev'}
    });
  }
  const addOnBtns = document.querySelectorAll('.addon-popup-trigger');
  addOnBtns.forEach((el) => {
    el.addEventListener('click',(e) => {
      if(e.target.nodeName == 'INPUT'){
        e.preventDefault();
        setTimeout(() => {
          if(e.target.checked){
            e.target.checked = false;
            qvUpdateATCbtn();
          } else {
            openQuickView(e,el);
          }
        },0);
      } else {
        openQuickView(e,el);
      }
    });
  });

  const addOnCheckboxes = document.querySelectorAll('.addon-card__checkbox:not(.addon-popup-trigger)');
  addOnCheckboxes.forEach((el) => {
    el.addEventListener('change',(e) => {
      qvUpdateATCbtn();
    });
  });

  function openQuickView(e,el){
    removeQuickView();
    var card = e.target.closest('.addon-card');
    fetch(`/products/${card.dataset.handle}?view=ajax.quick-view&variant=${card.dataset.id}`).then((response) => response.text()).then((text) => {
      var html = hwDOMParser.parseFromString(text,'text/html');
      var qv = html.getElementById('quick-view');
      document.body.append(qv);
      initQuickView(el);
    });
  }

  var qvVariants = null;
  var qvSelectedVariant = null;

  function initQuickView(triggerBtn){
    qvVariants = JSON.parse(document.getElementById('quick-view-variants').innerHTML);
    qvSelectedVariant = qvVariants[0];
    var qvOptionInputs = document.querySelectorAll('.qv-option__input');
    var qvImg = document.getElementById('quick-view-img');
    var qvPrice = document.getElementById('quick-view-price');
    var qvComparePrice = document.getElementById('quick-view-compare-price');
    qvQtyInput = document.getElementById('qv-quantity');
    qvUpdateOptions(null);
    document.getElementById('quick-view-close').focus();
    qvOptionInputs.forEach((input) => {
      input.addEventListener('change',(changeEvt) => {
        var selectedOptions = Array.from(qvOptionInputs).filter(el => el.checked).map(el => el.value);
        var variantSet = qvVariants;
        for (let x = 0; x < selectedOptions.length; x++) {
          variantSet = variantSet.filter(v => v.options[x] == selectedOptions[x]);
        }
        qvSelectedVariant = variantSet[0];
        if(!qvSelectedVariant){
          var optVars = qvVariants.filter((variant) => variant.option1 == selectedOptions[0]);
          if(selectedOptions.length == 3 && input.dataset.optionPosition == "2"){
            optVars = optVars.filter((variant) => variant.option2 == selectedOptions[1]);
          }
          qvSelectedVariant = optVars[0];
        }
        qvUpdateOptions(input);
        updateAddOnImg(qvImg,qvSelectedVariant);
        qvPrice.textContent = formatPrice(qvSelectedVariant.price);
        if(qvSelectedVariant.compare_at_price){
          qvComparePrice.textContent = formatPrice(qvSelectedVariant.compare_at_price);
          qvPrice.classList.add('color--dark-red');
        } else {
          qvComparePrice.textContent = "";
          qvPrice.classList.remove('color--dark-red');
        }
      });
    });

    document.querySelectorAll('.quick-view-close').forEach((btn) => {
      btn.addEventListener('click',(clickEvt) => {
        if(btn.classList.contains('quick-view__add')){
          if (btn.dataset.contactSales === 'true') { return; }
          var card = triggerBtn.closest('.addon-card');
          var cardImg = card.querySelector('img');
          var cardPrice = card.querySelector('.addon-card__price');
          card.dataset.id = qvSelectedVariant.id;
          card.dataset.qty = qvQtyInput.value || 1;
          var triggerInput = card.querySelector('.addon-card__checkbox');
          triggerInput.checked = true;
          updateAddOnImg(cardImg,qvSelectedVariant);
          cardPrice.textContent = '+' + formatPrice(qvSelectedVariant.price);
          qvUpdateATCbtn();
        }
        removeQuickView(triggerBtn);
      });
    });
  }

  function qvUpdateOptions(inputEl){
    if(qvSelectedVariant.option2 !== null){
      var option1Vars = qvVariants.filter((variant) => variant.option1 == qvSelectedVariant.option1);
      var option2Vals = option1Vars.map((variant) => variant.option2);
      var option2Els = document.querySelectorAll('.qv-option-2-value');
      qvShowHideVals(option2Els,option2Vals,qvSelectedVariant.option2);
      if(qvSelectedVariant.option3 !== null){
        var option2Vars = option1Vars.filter((variant) => variant.option2 == qvSelectedVariant.option2);
        var option3Vals = option2Vars.map((variant) => variant.option3);
        var option3Els = document.querySelectorAll('.qv-option-3-value');
        qvShowHideVals(option3Els,option3Vals,qvSelectedVariant.option3);
      }
    }
    if(!inputEl){
      var inputEl = document.querySelector('.qv-option__input:checked');
    }
    if(inputEl){
      const selectedText = inputEl.closest('.qv-option').querySelector('.qv-option__selected');
      if(selectedText){
        selectedText.textContent = inputEl.dataset.value;
      }
    }
  }

  function qvShowHideVals(els,vals,selected){
    els.forEach(function(el){
      var inputEl = el.querySelector('input');
      if(vals.includes(el.dataset.optionValue)){
        el.classList.remove('hide');
        if(el.dataset.optionValue == selected){
          inputEl.checked = true;
          inputEl.closest('.qv-option').querySelector('.qv-option__selected').textContent = inputEl.dataset.value;
        } else {
          inputEl.checked = false;
        }
      } else {
        el.classList.add('hide');
        inputEl.checked = false;
      }
    });
  }

  function updateAddOnImg(el,variant){
    var src = variant.featured_image ? variant.featured_image.src : el.dataset.original;
    var params = new URLSearchParams(el.currentSrc);
    var size = params.get('width');
    el.srcset = `${src}&width=${size} ${size}w`;
  }

  function removeQuickView(triggerBtn){
    const existing = document.getElementById('quick-view');
    if(existing){
      existing.remove();
    }
    if(triggerBtn){
      triggerBtn.focus();
    }
  }
});

function pdpAddOnsATC(selectedAddOns,addObj,thisBtn){
  var addOnItems = [];
  var addOnFetches = [];
  selectedAddOns.forEach((el) => {
    const card = el.closest('.addon-card');
    const addOn = {id: parseInt(card.dataset.id), quantity: (card.dataset.qty || 1)};
    addOnItems.push(addOn);
    addOnFetches.push(fetch(`/products/${card.dataset.handle}?view=pdp-data`).then((response) => response.text()).then((data) => {return JSON.parse(data)}) );
  });
  async function getAddOnData(){
    await Promise.all(addOnFetches).then((results) => {
      for(var i = 0; i < addOnItems.length; i++){
        var addOnItem = addOnItems[i];
        const variant = results[i].variants[addOnItem.id];
        const addonProperties = pdpAddItemProperties(variant);
        if(JSON.stringify(addonProperties) !== '{}'){
          addOnItem.properties = addonProperties;
        }
        addObj.items.push(addOnItem);
      }
      pdpExecuteAdd(addObj,thisBtn);
    })
    .catch((e) => {
      console.error(e);
    });
  }
  getAddOnData();
}